<div class="container">
    <div class="wrapper">
        <div class="row">

            <div class="col-sm-12 mb-2">
                <h1 class="pageTitle">Accessibility Statement</h1>
                <div *ngIf="datastoreService.config" [innerHTML]="datastoreService.config?.accessibilityStatementPage?.pageContent"></div>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-6">
                <button type="button" class="btn btn-primary govuk-button button-sizer" (click)="routerGoBack()"
                    title="Back" aria-label="Back to location"><span>
                        <fa-icon [icon]="faChevronLeft"></fa-icon><span>{{'COMMON.BACK' | translate}}</span>
                    </span></button>
            </div>

        </div>
        <br>
    </div>
</div>